module.exports = __webpack_public_path__ + "static/media/instagram.fd64a3af.svg";